import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Headphones, Copy, RefreshCw, ExternalLink, Loader2 } from "lucide-react";
import { t } from "../i18n";

export function OperatorModal({ open, onOpenChange, overlayId }) {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get(`/overlays/${overlayId}/operator`)
      .then(({ data }) => setToken(data.operator_token))
      .catch(() => toast.error(t("Falha ao carregar link")))
      .finally(() => setLoading(false));
  }, [open, overlayId]);

  const url = token ? `${window.location.origin}/operator/${overlayId}?key=${token}` : "";

  const copy = () => { navigator.clipboard.writeText(url); toast.success(t("Link do operador copiado!")); };
  const regen = async () => {
    try {
      const { data } = await api.post(`/overlays/${overlayId}/operator/regenerate`);
      setToken(data.operator_token);
      toast.success(t("Novo link gerado. O link anterior deixou de funcionar."));
    } catch { toast.error(t("Falha ao gerar link")); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="operator-modal">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Headphones className="h-5 w-5 text-primary" /> {t("Link do operador")}</DialogTitle>
          <DialogDescription>
            {t("Compartilhe este link com quem vai controlar o overlay ao vivo (ligar/desligar elementos, placar, cronômetro, chat) — sem precisar de login. Ele não pode editar o design.")}
          </DialogDescription>
        </DialogHeader>

        {loading ? (
          <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>
        ) : (
          <>
            <div className="flex items-center gap-1 bg-black/40 border border-border rounded-sm pl-2 pr-1 h-10 min-w-0 overflow-hidden">
              <span className="font-mono text-[11px] text-muted-foreground truncate flex-1 min-w-0" data-testid="operator-url">{url}</span>
              <button onClick={copy} className="p-2 hover:text-primary text-muted-foreground flex-shrink-0" data-testid="operator-copy-btn"><Copy className="h-4 w-4" /></button>
            </div>
            <div className="flex gap-2">
              <Button onClick={() => window.open(url, "_blank")} variant="secondary" className="flex-1 rounded-sm" data-testid="operator-open-btn">
                <ExternalLink className="h-4 w-4 mr-2" /> {t("Abrir painel")}
              </Button>
              <Button onClick={regen} variant="outline" className="rounded-sm" data-testid="operator-regen-btn">
                <RefreshCw className="h-4 w-4 mr-2" /> {t("Gerar novo")}
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
